export default __webpack_public_path__ + "static/keyboard-1-seconds-ffcbbf0c11dee1cbdac636085456175a.mp3";